import React from 'react';
import { Modal } from 'react-bootstrap';
import FormPasswordContainer from '../../../redux/containers/FormPasswordContainer';

class AccountPassword extends React.Component {
  constructor() {
    super();
    this.state = { showModal: false };
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
  }

  close() {
    this.setState({ showModal: false });
  }

  open(e) {
    e.preventDefault();
    this.setState({ showModal: true });
  }

  render() {
    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-xs-12">
              <h3 className="half-charcoal">Set up your Unlimited Skinny Broadband Account</h3>
              <p className="bold">
                This is different from your Skinny Mobile account.&nbsp;
                <a href="/" onClick={this.open}>Why?</a>
              </p>
              <p>
                So you can access your Skinny Unlimited Broadband account, you just need to choose a password.
                Keep this handy for next time.
              </p>
              <Modal dialogClassName="skinny-modal" show={this.state.showModal} onHide={this.close}>
                <Modal.Header closeButton />
                <Modal.Body>
                  <p className="skinny-modal-text">
                    Because we are using a different technology for Skinny Unlimited Broadband, we need to set up a
                    new account for you. When you log in next time, just make sure you select the &apos;Skinny Unlimited
                    Broadband&apos; tab.
                  </p>
                </Modal.Body>
              </Modal>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <FormPasswordContainer
                name="password"
                autotestClass="autotest-password"
                label="Password"
                placeholder="Password"
                maxLength={100}
                required
              />
            </div>
            <div className="col-sm-6">
              <FormPasswordContainer
                name="confirmPassword"
                autotestClass="autotest-confirm-password"
                label="Confirm password"
                placeholder="Confirm password"
                maxLength={100}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <small>
                Your password needs to contain at least 8 characters, one upper case and one numeric character.
              </small>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AccountPassword;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/AccountPassword/AccountPassword.js
 **/